import React from "react";

import Debriefing from "root/icons/Debriefing";

// -------------------------------------------------------------------------
const debriefingSection = {
  type: "section",
  title: "Аналитика продаж",
  icon: Debriefing,
  noProd: true,
  children: [
    {
      url: "/sales-analytics-settings",
      component: React.lazy(() => import("root/pages/sales-analytics-settings/App")),
      title: "Настройки и данные",
    },
    {
      url: "/cost_price",
      component: React.lazy(() => import("root/pages/cost_price/App")),
      title: "Себестоимость товаров",
    },
    {
      url: "/settings-debriefing",
      component: React.lazy(() => import("root/pages/settings-debriefing/App")),
      title: "Настройки OLD",
      onlyInDev: true,
    },
    {
      title: "Wildberries",
      url: "/sales-analytics-wb",
      component: React.lazy(() => import("root/pages/sales-analytics-wb/App")),
    },
    {
      title: "Аналитика продвижения",
      url: "/sales-promotion-analytics",
      component: React.lazy(() => import("root/pages/sales-promotion-analytics/App")),
    },
    {
      title: "Wildberries OLD",
      url: "/wildberries",
      component: React.lazy(() => import("root/pages/wildberries/App")),
      onlyInDev: true,
    },
    {
      title: "Ozon",
      url: "/sales-analytics-ozon",
      component: React.lazy(() => import("root/pages/sales-analytics-ozon/App")),
      onlyInDev: true,
    },
    {
      title: "Управление запасами",
      url: "/inventory-management",
      component: React.lazy(() => import("root/pages/inventory-management/App")),
      onlyInDev: true,
    },
    {
      title: "Управление запасами v2",
      url: "/sales-analytics-warehouses",
      component: React.lazy(() => import("root/pages/sales-analytics-warehouses/App")),
      onlyInDev: true,
    },
    {
      title: "Внешние операции",
      url: "/external-operations",
      component: React.lazy(() => import("root/pages/external-operations/App")),
      onlyInDev: true,
    },
    {
      title: "Список статей",
      url: "/manage-operation-groups",
      component: React.lazy(() => import("root/pages/external-operations-groups/App")),
      onlyInDev: true,
    },
    // -------------------------------------------------------------------
    // Разделы ниже были в планах, необходимо проверить их актуальность и
    // скорее всего удалить
    // -------------------------------------------------------------------
    // {
    //   url: "/ai",
    //   component: React.lazy(() => import("root/pages/ai/App")),
    //   title: "AI “автопилот”",
    // },
    {
      url: "/business-analytics",
      component: React.lazy(() => import("root/pages/business-analytics/App")),
      title: "Бизнес-аналитика OLD",
    },
    {
      url: "/sales-analytics-business",
      component: React.lazy(() => import("root/pages/sales-analytics-business/App")),
      title: "Бизнес-аналитика",
      onlyInDev: true,
    },
    // {
    //   url: "/yandex",
    //   component: React.lazy(() => import("root/pages/yandex/App")),
    //   title: "Яндекс Маркет",
    // },
    // {
    //   url: "/products-monitoring",
    //   component: React.lazy(() => import("root/pages/products-monitoring/App")),
    //   title: "Мониторинг товаров",
    // },
    // {
    //   url: "/price-management",
    //   component: React.lazy(() => import("root/pages/price-management/App")),
    //   title: "Управление ценами",
    // },
    // {
    //   url: "/advertisement",
    //   component: React.lazy(() => import("root/pages/advertisement/App")),
    //   title: "Управление рекламой",
    // },
    // {
    //   url: "/wms",
    //   component: React.lazy(() => import("root/pages/WMS/App")),
    //   title: "Целевая WMS",
    // },
    // {
    //   url: "/faq",
    //   component: React.lazy(() => import("root/pages/FAQ/App")),
    //   title: "F.A.Q.",
    // }
    // {
    // 	url: "solution-fbs",
    // 	component: React.lazy(() => import("root/pages/solutions-for-fbs/App")),
    // 	title: "Решения для FBS",
    // },
    // {
    // 	url: "/inventory-management",
    // 	component: React.lazy(() => import("root/pages/support-services/App")),
    // 	title: "Инструменты нейросетей",
    // },
    // {
    // 	url: "/business-economic",
    // 	component: React.lazy(() => import("root/pages/business-economic/App")),
    // 	title: "Экономика бизнеса",
    // },
  ],
};

export default debriefingSection;
